import { useTranslation } from 'react-i18next'
import ErrorBlock from './components/ErrorBlock'

export default function NotFoundPage() {
  const { t } = useTranslation()
  return <ErrorBlock status={404} title={t('not-found')} extraText={t('access-denied.footer')} />
}
